<template>
  <default-layout>
    <div class="listings">
      <b-container class="pt-4">
        <div class="py-2">
          <h1 class="h3">
            {{ title }}
          </h1>
          <h5
            v-if="!isListingsLoading"
            class="text-muted">{{listings.length}} results</h5>
        </div>
        <div
          v-if="isListingsLoading"
          class="text-center py-5">
          <p class="h6 mb-4">
            Finding the latest listings...
          </p>
          <b-spinner
            variant="primary"/>
        </div>
        <div
          v-else-if="listings.length"
          class="row py-2">
          <div
            class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
            :key="listing.id"
            v-for="listing in listings">
            <listing-card
              :listing="listing"
              class="mb-5"/>
          </div>
        </div>
        <b-card
          v-else
          class="py-5 text-center">
          <h4 class="h5">
            No listings in this category
          </h4>
          <p>
            We weren't able to find any listings in this category.
            <br>
            Please check back later&mdash;we're always adding new items!
          </p>
          <b-button
            @click="$router.push('/listings')"
            size="md"
            variant="outline-dark"
            squared>
            Browse All Listings
          </b-button>
        </b-card>
        <!-- <div class="py-1">
          <b-pagination
            v-model="paginationPage"
            align="center"
            :total-rows="paginationTotalRows"
            :per-page="paginationPerPage"
            size="md"/>
        </div> -->
      </b-container>
    </div>
  </default-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import ListingCard from '@/components/listings/ListingCard.vue'

export default {
  name: 'Listings',
  components: {
    ListingCard,
  },
  async created() {
    this.syncRegionFromRoute()
    this.getListings()
  },
  data() {
    return {
      listings: [],
      isListingsLoading: true,
      paginationPerPage: 12,
    }
  },
  computed: {
    ...mapGetters('Region', { currentRegion: 'current' }),
    regionSlug() {
      return this.$route.params.regionSlug || this.currentRegion.slug
    },
    title() {
      const scope = this.subcategory || this.category
      return scope
        ? `${scope} in ${this.currentRegion.name}`
        : `Listings in ${this.currentRegion.name}`
    },
    category() {
      return this.$route.query.category
        ? this.$route.query.category
          .split('-')
          .map(w => w.slice(0, 1).toUpperCase() + w.slice(1))
          .join(' ')
        : undefined
    },
    subcategory() {
      return this.$route.query.subcategory
        ? this.$route.query.subcategory
          .split('-')
          .map(w => w.slice(0, 1).toUpperCase() + w.slice(1))
          .join(' ')
        : undefined
    },
    paginationTotalRows() {
      return 1
    },
    paginationPage: {
      get() {
        return this.$route.query.page || 1
      },
      set(newPage) {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: newPage,
          },
        })
      },
    },
  },
  methods: {
    syncRegionFromRoute() {
      // If the URL has a region slug that differs from the toolbar selection,
      // update the store so the rest of the UI stays in sync (e.g. shareable
      // links land you on the right region).
      const routeSlug = this.$route.params.regionSlug
      if (routeSlug && routeSlug !== this.currentRegion.slug) {
        this.$store.dispatch('Region/setRegion', routeSlug)
      }
    },
    async getListings() {
      this.isListingsLoading = true
      try {
        const { data: { listings } } = await this.$http.get('/listings', {
          params: {
            region: this.regionSlug,
            category: this.$route.query.category,
            subcategory: this.$route.query.subcategory,
          },
        })
        this.listings = listings
      } catch (err) {
        this.listings = []
        console.error('Failed to load listings', err)
      }
      this.isListingsLoading = false
      document.title = `${this.title} - ZoopLocal`
    },
  },
  watch: {
    '$route.query.category': function watchRoutePath() { this.getListings() },
    '$route.query.subcategory': function watchRoutePath() { this.getListings() },
    '$route.params.regionSlug': function watchRegion() {
      this.syncRegionFromRoute()
      this.getListings()
    },
  },
}
</script>

<style lang="scss">
</style>
